import { createSlice } from "@reduxjs/toolkit";
import { FeatureApiItem } from "./Types";

import { FeatureTechnologyOption } from "./Types";

type initialStateType = {
  features: FeatureApiItem[];
  technologyOptions: FeatureTechnologyOption[];
  inactiveTechnologyOptions: FeatureTechnologyOption[];
  status: {
    featuresLoading: boolean;
    technologyOptionsLoading: boolean;
    createFeatureLoading: boolean;
    updateFeatureLoading: boolean;
    deleteFeatureLoading: boolean;
  };
};

const initialState: initialStateType = {
  features: [],
  technologyOptions: [],
  inactiveTechnologyOptions: [],
  status: {
    featuresLoading: false,
    technologyOptionsLoading: false,
    createFeatureLoading: false,
    updateFeatureLoading: false,
    deleteFeatureLoading: false,
  },
};

const featureManagementSlice = createSlice({
  name: "feature-management",
  initialState,
  reducers: {
    setFeatures: (state, action) => {
      state.features = action.payload;
    },
    setTechnologyOptions: (state, action) => {
      state.technologyOptions = action.payload;
    },
    setInactiveTechnologyOptions: (state, action) => {
      state.inactiveTechnologyOptions = action.payload;
    },
    setFeaturesLoading: (state, action) => {
      state.status.featuresLoading = action.payload;
    },
    setTechnologyOptionsLoading: (state, action) => {
      state.status.technologyOptionsLoading = action.payload;
    },
    setCreateFeatureLoading: (state, action) => {
      state.status.createFeatureLoading = action.payload;
    },
    setUpdateFeatureLoading: (state, action) => {
      state.status.updateFeatureLoading = action.payload;
    },
    setDeleteFeatureLoading: (state, action) => {
      state.status.deleteFeatureLoading = action.payload;
    },
  },
});

export const featureManagementSliceReducer = featureManagementSlice.reducer;
export const featureManagementSliceAction = featureManagementSlice.actions;
